module.exports = __webpack_public_path__ + "img/mixerTruk-red.780f7ea6.svg";